import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PUBLIC_PATHS = new Set(["/", "/login", "/signup", "/home"]);

function isPublicPath(pathname) {
  const p = pathname.replace(/\/+$/, "") || "/";
  return PUBLIC_PATHS.has(p);
}

export default function AuthAutoRedirect() {
  const { authenticated } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (authenticated && isPublicPath(location.pathname)) {
      navigate("/dashboard", { replace: true });
    }
  }, [authenticated, location.pathname, navigate]);

  return null; 
}
